/**
 * App.tsx — composition root.
 * ThemeProvider (light/dark via <html data-theme>) + BridgeProvider (the
 * reactive store) wrap the single-surface SK Bridge AppShell.
 */
import React from 'react';

import { ThemeProvider } from './src/context/themeContext';
import { BridgeProvider } from './src/store/bridgeStore';
import AppShell from './src/shell/AppShell';
import SessionGate from './src/shell/SessionGate';

export default function App() {
  return (
    <ThemeProvider>
      {/* Outside BridgeProvider: no tenant data is fetched until we know who
          is signed in, so the store never boots against an anonymous session. */}
      <SessionGate>
        <BridgeProvider>
          <AppShell />
        </BridgeProvider>
      </SessionGate>
    </ThemeProvider>
  );
}
